import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

import { AuthComponent } from './auth/auth.component';
import { SecuredComponent } from './secured/secured.component';

const routes: Routes = [
  {
    // Veřejné (nepřihlášené) stránky účtu - dokončení pozvánky a reset zapomenutého hesla.
    // URL musí přesně odpovídat tomu, co generuje backend `UserTokenService`
    // (`{BaseUrl}/ucet/pozvanka`, `/ucet/reset`) a odkazu na loginu.
    path: 'ucet',
    loadChildren: () => import('./public/account/public-account.module').then(m => m.PublicAccountModule)
  },
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      { path: 'login', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
      { path: '', redirectTo: 'login', pathMatch: 'full' }
    ]
  },
  { 
    path: 'secured', 
    component: SecuredComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'transfers', loadChildren: () => import('./features/transfers/transfers.module').then(m => m.TransfersModule) },
      { path: 'transfers-between', loadChildren: () => import('./features/transfers-between/transfers-between.module').then(m => m.TransfersBetweenModule) },
      { path: 'clubs', loadChildren: () => import('./features/clubs/clubs.module').then(m => m.ClubsModule) },
      { path: 'players', loadChildren: () => import('./features/players/players.module').then(m => m.PlayersModule) },
      { path: 'assistant', loadChildren: () => import('./features/assistant/assistant.module').then(m => m.AssistantModule) },
      { path: 'proposals', redirectTo: 'assistant/proposals', pathMatch: 'full' },
      { path: 'users', loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule) },
      { path: 'knowledge', loadChildren: () => import('./features/knowledge/knowledge.module').then(m => m.KnowledgeModule) },
      { path: 'audit', loadChildren: () => import('./features/audit/audit.module').then(m => m.AuditModule) },
      { path: 'price-tables', loadChildren: () => import('./features/price-tables/price-tables.module').then(m => m.PriceTablesModule) },
      { path: 'contract-templates', loadChildren: () => import('./features/contract-templates/contract-templates.module').then(m => m.ContractTemplatesModule) },
      { path: 'import', loadChildren: () => import('./features/import/import.module').then(m => m.ImportModule) },
      { path: 'communication', loadChildren: () => import('./features/communication/communication.module').then(m => m.CommunicationModule) },
    ]
  },
  {
    // Veřejná oblast: rozcestník (''), nová žádost, ověření stavu. Anonymní, bez app chrome.
    path: '',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule)
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
